<template>
  <div class="commodity">
    <div class="contentRight2">
      <div class="contentTabs">
        <!-- 顶部tab栏 -->
        <el-tabs v-model="activeName" style="height: 100%" @tab-click="flTab">
          <el-tab-pane label="商品管理" style="height: 100%" name="first">
            <div style="height: 100%">
              <div class="commodityHead row">
                <el-button class="button" type="primary" @click="add"
                  >新建商品</el-button
                >
              </div>
              <!-- 左侧tab栏 -->
              <div id="topTabs" class="leftTabs row">
                <div class="nav">
                  <div
                    @click="navIndex(index, item)"
                    :class="
                      indexNumber !== index ? 'navBlock' : 'navBlock_click'
                    "
                    v-for="(item, index) in categoryList"
                    :key="index"
                  >
                    {{ item.categoryName }}
                  </div>
                </div>
                <div class="navContent">
                  <!-- 商品列表 -->
                  <div v-if="commidityList.length !== 0" class="commidity">
                    <div
                      class="commidityItem row alignCenter"
                      v-for="(item, index) in commidityList"
                      :key="index"
                    >
                      <!-- //商品 -->
                      <div v-if="item.saleStatus == 0" class="commidityItemImg">
                        <img :src="item.goodsImage" alt />
                      </div>
                      <div
                        v-if="item.saleStatus == 1"
                        class="commidityItemImg2"
                      >
                        <div v-if="item.goodsImage">
                          <img :src="item.goodsImage" alt />
                        </div>
                        <div v-if="!item.goodsImage">
                          <img src="../../assets/icon/defaultPic.png" alt />
                        </div>
                      </div>
                      <div style="margin-left: 10px">
                        <div v-if="item.saleStatus == 1" class="goodName">
                          {{ item.goodsName }}
                        </div>
                        <div
                          v-if="item.saleStatus == 0"
                          class="goodName"
                          style="color: #b2b2b2"
                        >
                          {{ item.goodsName }}
                        </div>
                        <div class="row" style="margin-top: 10px">
                          <div class="red">{{ item.retailScore }}个积分</div>
                          <div v-if="!item.isInfiniteStock" class="num">
                            库存：{{ item.totalStockCount }}
                          </div>
                          <div v-if="item.isInfiniteStock" class="num">
                            库存：无限库存
                          </div>
                        </div>
                      </div>
                      <!-- 按钮组 -->
                      <div style="position: absolute; right: 20px">
                        <el-button
                          v-if="item.saleStatus == 1"
                          class="button2"
                          @click="allSoldOut2(item)"
                          >下架</el-button
                        >
                        <el-button
                          v-if="item.saleStatus == 0"
                          class="button"
                          @click="allPutAway2(item)"
                          >上架</el-button
                        >
                        <el-button class="button2" @click="editGoods(item)"
                          >编辑</el-button
                        >
                        <!-- 改分类弹出层 -->
                        <el-popover
                          :value="isValue"
                          ref="cateRadio"
                          id="display"
                          placement="bottom"
                          width="150"
                          trigger="click"
                        >
                          <div
                            v-for="(item2, index2) in categoryList"
                            :key="index2"
                          >
                            <div
                              v-if="item2.categoryName !== '全部'"
                              class="classfiyPop"
                            >
                              <el-radio
                                :label="item2.categoryName"
                                @change="cateClick(item, item2)"
                                v-model="radio"
                                class="marginRight10"
                              ></el-radio>
                            </div>
                          </div>
                          <div class="br"></div>
                          <div class="center">
                            <el-button
                              class="button button3"
                              @click="cateChange(index)"
                              type="primary"
                              :disabled="radio == ''"
                              >保存</el-button
                            >
                            <el-button
                              class="button button3"
                              @click="cateOut(index)"
                              >取消</el-button
                            >
                          </div>

                          <el-button
                            class="button"
                            slot="reference"
                            @click="handleReset(item)"
                            >改分类</el-button
                          >
                        </el-popover>
                        <el-button class="button" @click="delGoods(item)"
                          >删除</el-button
                        >
                      </div>
                    </div>
                    <!-- 分页 -->
                    <div class="block" style="float: right; margin-top: 10px">
                      <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pageNum"
                        :page-size="queryInfo.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                      ></el-pagination>
                    </div>
                  </div>
                  <div
                    v-if="commidityList.length == 0"
                    class="commidity"
                    style="padding: 20px 20px"
                  >
                    暂无商品
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- 分类管理标签页面 -->
          <el-tab-pane
            id="fenye"
            style="height: 100%"
            label="分类管理"
            name="second"
          >
            <div class="commodityHead row alignCenter">
              <el-button
                class="button"
                type="primary"
                @click="dialogVisible = true"
                >新建分类</el-button
              >
            </div>
            <div style="padding: 30px; margin-top: 60px">
              <!-- 表格 -->
              <el-table :data="tableData" style="width: 100%">
                <el-table-column
                  align="left"
                  prop="categoryName"
                  label="分类"
                  width="180"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  class-name="tableHead"
                  align="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="updateCateName(scope.row)"
                      >编辑</el-button
                    >
                    <el-button size="mini" @click="deleteCateName(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="block"
                v-if="totalCount"
                style="float: right; margin-top: 10px"
              >
                <el-pagination
                  @current-change="handleCurrentChange1"
                  :current-page.sync="queryInfo.pageNum"
                  :page-size="queryInfo.pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="新建分类" :visible.sync="dialogVisible" width="30%">
      <span>分类名：</span>
      <el-input
        style="margin: 20px 0"
        v-model="category.value"
        placeholder="分类名"
      ></el-input>
      <span slot="footer" class="dialog-footer" style="z-index: 2100">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createCate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑分类" :visible.sync="dialogVisible1" width="30%">
      <span>分类名：</span>
      <el-input
        style="margin: 20px 0"
        v-model="categoryEdit.value"
        placeholder="分类名"
      ></el-input>
      <span slot="footer" class="dialog-footer" style="z-index: 2100">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getOfficialGoodsCategoryList,
  getGoodsCategoryListTotalNum,
  getOfficialGoodsList,
  getOfficialGoodsListTotalNum,
  modifyOfficialGoodsSaleStatus,
  modifyOfficialGoodsCategory,
  deleteOfficialGoods,
  modifyOrSaveOfficialGoodsCategory,
  deleteOfficialGoodsCategory
} from "../api";
import draggable from "vuedraggable";
export default {
  name: "integralManage",
  components: {
    draggable
  },
  data() {
    return {
      activeName: "first",
      commidityList: [],
      total: 0,
      categoryList: [],
      indexNumber: 0,
      queryInfo: {
        pageNum: 1,
        pageSize: 10
      },
      radio: "",
      isValue: false,
      cateArr: {},
      tableData: [],
      totalCount: 0,
      category: {
        value: ""
      },
      dialogVisible: false,
      dialogVisible1: false,
      categoryEdit: {
        value: "", 
        officialGoodsCategoryId: ""
      }
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.getOfficialGoodsCategoryList(1, 999);
  },
  methods: {
    //分类管理标签
    flTab(tab, event) {
      if (tab.label == "商品管理") {
        this.getOfficialGoodsCategoryList(1, 999);
      } else if (tab.label == "分类管理") {
        this.getOfficialGoodsCategoryList(1, 10);
      }
    },
    // 新建商品
    add() {
      this.$router.push( { path: "/addintegralGoods", query: { style: "create" } } )
    },
    // 编辑商品
    editGoods(item) {
      this.$router.push( { path: "/addintegralGoods", query: { style: "update", goodsId: item.officialGoodsId } } )
    },
    // 获取商品分类列表
    getOfficialGoodsCategoryList(pageNo, row) {
      getOfficialGoodsCategoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo: pageNo,
        row: row
      })
      .then(res => {
        this.getOfficialGoodsList()
        if (res.code == 1) {
          this.categoryList = res.data
          this.tableData = JSON.parse(JSON.stringify(res.data))
          this.categoryList.unshift( { categoryName: "全部", officialGoodsCategoryId: "" } )
          getGoodsCategoryListTotalNum({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            pageNo: this.queryInfo.pageNum,
            row: 999
          })
          .then(res => {
            if (res.code == 1) {

            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
        } else if (res.code == -1) {
          this.categoryList = []
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    navIndex(i, item) {
      this.indexNumber = i
      this.getOfficialGoodsList(item.officialGoodsCategoryId)
    },
    // 获取商品
    getOfficialGoodsList(officialGoodsCategoryId) {
      getOfficialGoodsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        officialGoodsCategoryId: officialGoodsCategoryId
      })
      .then(res => {
        if (res.code == 1) {
          this.commidityList = res.data
          getOfficialGoodsListTotalNum({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            pageNo: this.queryInfo.pageNum,
            row: this.queryInfo.pageSize,
            officialGoodsCategoryId: officialGoodsCategoryId
          })
          .then(res => {
            if (res.code == 1) {
              this.total = res.data.totalNum
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          })
        } else if (res.code == -1) {
          this.commidityList = []
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val
      this.getOfficialGoodsList()
    },
    handleCurrentChange1(val) {
      this.queryInfo.pageNum = val
      this.getOfficialGoodsCategoryList(val, 10)
    },
    // 下架
    allSoldOut2(item) {
      modifyOfficialGoodsSaleStatus({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialGoodsId: item.officialGoodsId,
        saleStatus: 0
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success("下架成功")
          this.getOfficialGoodsList()
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 上架
    allPutAway2(item) {
      modifyOfficialGoodsSaleStatus({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialGoodsId: item.officialGoodsId,
        saleStatus: 1
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success("上架成功")
          this.getOfficialGoodsList()
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 改分类按钮
    handleReset(item) {
      var index = this.categoryList.findIndex(element => {
        return element.officialGoodsCategoryId == item.officialGoodsCategoryId
      })
      if (index !== -1) {
        this.radio = this.categoryList[index].categoryName; 
      }
    },
    // 取消改分类
    cateOut(e) {
      this.$refs["cateRadio"][e].doClose();
    },
    // 选择修改后的分类名
    cateClick(item, item1) {
      this.cateArr.officialGoodsCategoryId = item1.officialGoodsCategoryId
      this.cateArr.officialGoodsId = item.officialGoodsId
    },
    // 保存
    cateChange(e) {
      modifyOfficialGoodsCategory({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialGoodsId: this.cateArr.officialGoodsId,
        officialGoodsCategoryId: this.cateArr.officialGoodsCategoryId
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success("修改分类成功")
          this.$refs["cateRadio"][e].doClose();
          this.getOfficialGoodsList()
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 删除
    delGoods(item) {
      this.$confirm("请确认是否删除商品" + item.goodsName, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
      .then(() => {
        deleteOfficialGoods({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          officialGoodsId: item.officialGoodsId
        })
        .then(res => {
          if (res.code == 1) {
            this.$message.success("删除商品" + item.goodsName + "成功")
            this.getOfficialGoodsList()
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
      })
      .catch(() => {});
    },
    updateCateName(item) {
      console.log(item)
      this.dialogVisible1 = true
      this.categoryEdit.value = item.categoryName
      this.categoryEdit.officialGoodsCategoryId = item.officialGoodsCategoryId
    },
    // 修改分类
    handleEdit() {
      modifyOrSaveOfficialGoodsCategory({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        categoryName: this.categoryEdit.value,
        officialGoodsCategoryId: this.categoryEdit.officialGoodsCategoryId
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success("修改分类成功")
          this.dialogVisible1 = false
          this.getOfficialGoodsCategoryList(1, 10);
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 新增分类
    createCate() {
      modifyOrSaveOfficialGoodsCategory({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        categoryName: this.category.value
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success("新建分类成功")
          this.dialogVisible = false
          this.getOfficialGoodsCategoryList(1, 10);
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 删除分类
    deleteCateName(item) {
      this.$confirm("请确认是否删除分类：" + item.categoryName, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
      .then(() => {
        deleteOfficialGoodsCategory({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          officialGoodsCategoryId: item.officialGoodsCategoryId
        })
        .then(res => {
          if (res.code == 1) {
            this.$message.success("删除分类成功")
            this.getOfficialGoodsCategoryList(1, 10);
          } else {
            this.$message.success(res.msg)
          }
        })
      })
      .catch(() => {});
    }
  },
};
</script>

<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 60px;
  position: fixed;
  top: 39px;
  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.button {
  width: 70px;
  height: 30px;
  padding: 0;
}
.button2 {
  width: 70px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
  margin-left: 0px;
}
.el-input__icon {
  line-height: 30px;
}

.el-input__inner {
  height: 30px;
}
.commidity {
  box-sizing: border-box;
  font-size: 16px;
  padding: 20px 20px 20px 20px;
}
.commidityItemImg img {
  height: 50px;
  width: 50px;
}
.commidityItemImg2 img {
  height: 50px;
  width: 50px;
}
.commidityItemImg {
  position: relative;
  height: 50px;
  width: 50px;
}
.commidityItemImg::before {
  content: "\5DF2\4E0B\67B6";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;

  line-height: 50px;
  font-size: 12px;
}
.commidityItem {
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.commidityItem:not(:first-child) {
  margin-top: 16px;
}
.red {
  color: red;
  font-size: 13px;
}
.num {
  color: #bbb;
  margin-left: 10px;
  font-size: 12px;
}
.member-price {
  color: #666;
  margin-left: 10px;
  font-size: 12px;
}
.classfiyPop {
  margin-top: 10px;
}
.br {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}
.button3 {
  height: 28px;
  width: 38px;
}
.leftTabs {
  margin-top: 59px;
  height: 100%;
  height: calc(100% - 59px);
}
.nav {
  background: #f8f8f8;
  width: 120px;
  height: calc(100vh - 100px);
  border-right: 1px solid #eeeeee;
  position: fixed;
  overflow-y: scroll;
}
.nav-hiddenScroll {
  background: #f8f8f8;
  width: 120px;
  height: calc(100vh - 100px);
  border-right: 1px solid #eeeeee;
  position: fixed;
  overflow-y: scroll;
}
.nav::-webkit-scrollbar {
  display: none;
}
.navBlock {
  box-sizing: border-box;
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.navBlock_click {
  background: #fff;
  box-sizing: border-box;
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.navContent {
  width: 100%;
  margin-left: 121px;
}
.display {
  display: none;
}
.goodName {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.el-table td,
.el-table th {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/page/integralManage.vue